import { supabase } from "../lib/supabase";

const invokeAdminFunction = async (name, body) => {
  const { data, error } = await supabase.functions.invoke(name, {
    body: JSON.stringify(body ?? {}),
  });

  if (error) {
    throw error;
  }

  if (typeof data === "string") {
    return JSON.parse(data || "null");
  }

  return data;
};

const fetchUsers = async () => {
  try {
    const response = await invokeAdminFunction("admin-users", {});
    return { data: response?.users || [], error: null };
  } catch (error) {
    console.error("admin-users invocation failed", error);
    return { data: [], error };
  }
};

const fetchUserDetails = async (userId) => {
  try {
    const response = await invokeAdminFunction("admin-user-details", { userId });
    return { data: response || null, error: null };
  } catch (error) {
    console.error("admin-user-details invocation failed", error);
    return { data: null, error };
  }
};

const updateUserRole = async (userId, newRole, actorId) => {
  try {
    const response = await invokeAdminFunction("admin-update-user-role", {
      userId,
      newRole,
      actorId,
    });
    return { data: response?.data || null, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

const updateUserStatus = async (userId, isActive, actorId) => {
  try {
    const response = await invokeAdminFunction("admin-update-user-status", {
      userId,
      isActive,
      actorId,
    });
    return { data: response?.data || null, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

const deleteUser = async (userId) => {
  try {
    const response = await invokeAdminFunction("admin-delete-user", { userId });
    return { data: response, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

const userService = {
  fetchUsers,
  fetchUserDetails,
  updateUserRole,
  updateUserStatus,
  deleteUser,
};

export default userService;
